import { ActionTree } from "vuex";
import { ActionCallback, RootState } from "../types";
import { CourseState } from "./types";
import CourseService from "@/services/course.service";
import { AxiosError, AxiosResponse } from "axios";
const service: CourseService = new CourseService();

export const actions: ActionTree<CourseState, RootState> = {
  getCourse(_, callback: ActionCallback) {
    service
      .getCourse(callback?.params)
      .then((response: AxiosResponse) => {
        if (response?.data) {
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
  getCourseDetail(_, callback: ActionCallback) {
    service
      .getCourseDetail(callback?.params.slug)
      .then((response: AxiosResponse) => {
        if (response?.data) {
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
  getCourseRating(_, callback: ActionCallback) {
    service
      .getCourseRating(callback?.params)
      .then((response: AxiosResponse) => {
        if (response?.data) {
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
};
